import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, AlertIcon, Box, Spinner, useToast, HStack } from "@chakra-ui/react";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import { getQuoteRequest } from "./services/PlacingAPI";
import { showApiErrorToast } from "./utils/showApiToast";
import CarrierQuoteRequestView from "./components/placing/CarrierQuoteRequestView";
import PlacementCodify from "./components/codify/PlacementCodify";

/** A quote request sent to one of the carrier's parties. */
const PlacingQuoteRequestPage = () => {
  const { quoteRequestId } = useParams();
  const toast = useToast();
  const [quoteRequest, setQuoteRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setQuoteRequest(await getQuoteRequest(quoteRequestId));
      setError(null);
    } catch (err) {
      setError(err);
      showApiErrorToast(toast, err, { title: "Couldn't load quote request" });
    } finally {
      setLoading(false);
    }
  }, [quoteRequestId, toast]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box position="relative" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />
      <Box p={6} maxW="1400px" mx="auto">
        {loading ? (
          <Spinner />
        ) : error || !quoteRequest ? (
          <Alert status="error"><AlertIcon />{error?.message || "Quote request not found."}</Alert>
        ) : (
          <>
            {/* Your own Codify setting and run for this message (it starts as the page loads it) */}
            <HStack justify="flex-end" mb={3} spacing={2}>
              <PlacementCodify placementId={quoteRequest.placementId} message={{ trigger: "quote_request", triggerId: quoteRequest._id }} refreshKey={quoteRequest._id} />
            </HStack>
            <CarrierQuoteRequestView quoteRequest={quoteRequest} onChanged={load} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default PlacingQuoteRequestPage;
